import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { ScheduleCallbackType } from "@/shared-types";

import type { CallbackRadioOption } from "./types";

import { DEFAULT_CALLBACK_NOW_DELAY } from "./types";
import { callbackTypeFromRadio } from "./utilities";

interface CallbacksFormState {
    callbackType: ScheduleCallbackType | null;
    callbackScheduled: boolean; //TODO: this should be a selector based on the sessions store and not a form state
    selectedCallbackOption: CallbackRadioOption;
    selectedCallbackNowDelay: number;
    selectedCallbackMdn: string;
}

interface CallbacksFormActions {
    resetState: () => void;

    setCallbackType: (selectedCallbackSpecificType: CallbackRadioOption) => void;
    setCallbackScheduled: (callbackScheduled: boolean) => void;
    setSelectedCallbackNowDelay: (selectedCallbackNowDelay: number) => void;
    setSelectedCallbackMdn: (selectedCallbackMdn: string) => void;
}

type CallbacksFormStore = CallbacksFormState & CallbacksFormActions;

const defaultCallbackFormState: CallbacksFormState = {
    callbackType: "CallbackNow",
    callbackScheduled: false,
    selectedCallbackOption: "callback-user-with-delay",
    selectedCallbackNowDelay: DEFAULT_CALLBACK_NOW_DELAY,
    selectedCallbackMdn: "",
};

const getCallbackNowDelay = (state: CallbacksFormState, selectedCallbackOption: CallbackRadioOption) => {
    if (selectedCallbackOption === "callback-user-now") {
        return 0;
    } else if (selectedCallbackOption === "callback-user-with-delay" && state.selectedCallbackNowDelay === 0) {
        return DEFAULT_CALLBACK_NOW_DELAY;
    }
    return state.selectedCallbackNowDelay;
};

// TODO: session refactor - Remove this store and use state instead
/** Only used for managing the callback UI state, the tasks actual callback state is handled in the SDK task store */
export const useCallbacksFormStore = create<CallbacksFormStore>()(
    devtools(
        (set) => ({
            ...defaultCallbackFormState,

            resetState: () => set(defaultCallbackFormState, false, "resetState"),
            setCallbackType: (selectedCallbackSpecificType) =>
                set(
                    (state) => ({
                        callbackType: callbackTypeFromRadio(selectedCallbackSpecificType),
                        selectedCallbackOption: selectedCallbackSpecificType,
                        selectedCallbackNowDelay: getCallbackNowDelay(state, selectedCallbackSpecificType),
                    }),
                    false,
                    "setCallbackType",
                ),

            setCallbackScheduled: (callbackScheduled) => set({ callbackScheduled }, false, "setCallbackScheduled"),

            setSelectedCallbackNowDelay: (selectedCallbackNowDelay) =>
                set({ selectedCallbackNowDelay }, false, "setSelectedCallbackNowDelay"),

            setSelectedCallbackMdn: (selectedCallbackMdn) =>
                set(
                    () => {
                        return { selectedCallbackMdn };
                    },
                    false,
                    "setSelectedCallbackMdn",
                ),
        }),
        {
            enabled: import.meta.env.VITE_ENV_TYPE !== "production",
            store: "callbacks-form",
            name: "workspace/call-controls",
        },
    ),
);
